<template>
    <ac-modal :title="companyName" ref="modal" :sizeClass="'modal-lg'">
        <div v-if="widgetReady">
            <employer-contributions :companyId="companyId" @contributions-updated="updateContributions">
                
            </employer-contributions>
        </div>
    </ac-modal>
</template>

<script>
import { compact } from 'lodash';
    import EmployerContributions from "./EmployerContributions.vue";

    export default {
        name: "EmployerContributionsModal",
        components: {EmployerContributions},
        data() {
            return {
                widgetReady: false,
                companyId: null,
                companyName: '',
                updateContributions: null,
            }
        },
        methods: {
            async showModal({companyId, companyName, updateContributions}) {
                this.widgetReady = false;
                this.companyId = companyId;
                this.companyName = companyName;
                this.updateContributions = updateContributions;
                this.widgetReady = true;
                this.$refs.modal.open();
            },
        }
    }

</script>

<style scoped>

</style>